import { useRouter } from './useRouter';
/**
 * Проверяет соответствие паттерну пути к переданному
 * @param pattern
 * @param strict
 * @param exact
 */
export function useRoute(pattern, strict, exact) {
    const router = useRouter();
    return router.matcher(pattern, router.getPath(), strict, exact);
}
